// extracted by mini-css-extract-plugin
module.exports = {"mainLayout":"style_mainLayout__2bGYd"};